<template>
  <v-container fluid>
    <vue-headful title="Benutzer" description="Online-Service Administration"/>
    <v-row>
      <v-col class="mt-n5">
        <div class="pb-3 d-flex">
          <div class="display-1">Benutzer</div>
          <v-text-field class="mt-n3 ml-5" v-model="searchString" label="Suche" prepend-inner-icon="mdi-magnify" hide-details style="max-width: 200px"></v-text-field>
        </div>
        <div class="d-flex">
          <v-checkbox class="mt-0" v-model="trial" label="FREE" hide-details></v-checkbox>
<!--          <v-checkbox class="mt-0 ml-5" v-model="trialOver" label="Abgelaufen" hide-details></v-checkbox>-->
          <v-checkbox class="mt-0 ml-5" v-model="kunde" label="PRO" hide-details></v-checkbox>
          <v-checkbox class="mt-0 ml-5" v-model="test" label="Tester" hide-details></v-checkbox>
          <v-checkbox class="mt-0 ml-5" v-model="inaktiv" label="Inaktiv" hide-details></v-checkbox>
          <v-checkbox class="mt-0 ml-5" v-model="newsletter" label="Newsletter" hide-details></v-checkbox>
        </div>
      </v-col>
    </v-row>
    <!--    <v-divider></v-divider>-->
    <!--    <p>Datenbankverbindung</p>-->
    <v-progress-linear v-if="loading" class="mr-10" indeterminate></v-progress-linear>
    <v-alert type="error" v-if="error">{{ reason }}</v-alert>

    <!--    <v-row class="mx-0" style="min-height: 40px;">-->
    <!--      <v-btn v-if="changed" dark @click="save">Speichern</v-btn>-->
    <!--      <v-btn class="ml-3" @click="onCreateUser">Benutzer anlegen</v-btn>-->
    <!--    </v-row>-->
    <v-row>
      <v-col>
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left" style="background-color: #dee1e6;">Name / Email</th>
              <th class="text-left" style="background-color: #dee1e6;">Activity</th>
              <th class="text-left" style="background-color: #dee1e6;">Account-Typ</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in filteredUsers" :key="user.Email">
              <td>
                <span v-if="!su && (user.IsSuperUser || user.IsAdmin)">
                  <v-icon class="mr-1">mdi-account-box</v-icon><b>{{ (user.Name || user.Email) }}</b>
                </span>
                <span v-else>
                  <v-icon class="mr-1">{{getUserIcon(user)}}</v-icon><router-link class="info--text"
                    :to="'/service/user/'+user.Email">{{ (user.Name || user.Email) }}</router-link>
                </span>

                <span>
                  {{ user.Email }}
                </span>
              </td>
              <td :class="activityClass(user)">{{formatDatum(LastActivity(user))}}</td>
              <td>{{ user.Plan }} {{planInfo(user)}}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <div>
      <div class="display-1 mt-10" >Emails</div>
      <pre>
        {{emails}}
      </pre>
    </div>
  </v-container>
</template>

<script>
import UserLib from "@/components/UserLib";
import {ArrayX} from "@/reusable/array_extensions";
import {formatDatum} from "@/reusable/date_and_time";
const {DateTime} = require("luxon");

const FETCH_AMOUNT = 10;
export default {
  name: 'Service_Users',
  components: {},
  data() {
    return {
      filteredUsers:[],
      users: [],
      loading: false,
      reason: '',
      error: false,
      offset: 0,
      searchString:'',
      newsletter:false,
      inaktiv:false,
      trial:true,
      // trialOver:true,
      test:true,
      kunde:true,
      emails:"",
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      this.$backend.get_users(FETCH_AMOUNT, this.offset, {onSuccess: this.onLoadSuccess, onError: this.onLoadError});
    },
    onLoadSuccess(data) {
      if (data.length == 0) {
        this.loading = false;
        return;
      }
      data.filter(x=>x.Email!=="null").forEach(x => this.users.push(x));
      this.offset += FETCH_AMOUNT;
      this.load();
    },
    onLoadError(reason) {
      this.loading = false;
      this.error = true;
      this.reason = reason;
    },
    isAdmin(user){
      return user.group===UserLib.GroupAdmin;
    },
    getUserIcon(user) {
      if (user.Product === UserLib.ProductPrivateUser)
        return 'mdi-account-circle';
      if (user.Group === UserLib.GroupDirector)
        return 'mdi-account-cowboy-hat';
      if (user.Group === UserLib.GroupTeamLeader)
        return 'mdi-account-group';
      return 'mdi-account-tie';
    },
    formatDatum(date) {
      if (!date)
        return "";
      return formatDatum(date);
    },
    LastActivity(user) {
      var date=user.LastActivity;
      if (!date || date.startsWith("0001"))
        date=user.CreationDate;
      return date;
    },
    activityClass(user) {
      var date=this.LastActivity(user);
      //console.log(user.Name, date);
      if (!date)
        return "grey";
      var datetime=DateTime.fromJSDate(new Date(date));
      var days = Math.abs( datetime.diffNow("days").days);
      if (days <= 7)
        return "chartreuse";
      if (days <= 14)
        return "green";
      if (days <= 30)
        return "yellow";
      if (days <= 90)
        return "orange";
      return "red";
    },
    planInfo(user) {
      if (user.Plan!=="trial")
        return "";
      var date = UserLib.getExpirationDate(user);
      if (DateTime.fromJSDate(new Date(date)) < DateTime.fromJSDate(new Date(Date.now())))
        return `(abgelaufen am ${this.formatDatum(date)})`;
      return `(bis ${this.formatDatum(date)})`;
    },
    updateFilter() {
      var result=[];
      var emails="";
      this.users.forEach(u=>{
        u.accountType=this.planInfo(u);
        if (this.searchString && JSON.stringify(u).toLowerCase().indexOf(this.searchString.toLowerCase()) < 0)
            return;
        if (!this.inaktiv && this.activityClass(u)==='red')
          return;
        if (!this.trial && u.Plan.indexOf("trial") >= 0)
          return;
        if (!this.test && u.Plan.indexOf("test") >= 0)
          return;
        if (!this.kunde && u.Plan.indexOf("paying") >= 0)
          return;
        if (this.newsletter && u.Newsletter != true)
          return;
        result.push(u);
        emails = emails + "\n" + u.Email;
      });
      this.filteredUsers=result;
      this.emails=emails;
    }
  },
  computed: {
    su() {
      return this.$app.is_super_user;
    },
    admin() {
      return this.$app.is_admin;
    },
  },
  watch: {
    searchString() {
      this.updateFilter();
    },
    users() {
      this.updateFilter();
    },
    inaktiv() {
      this.updateFilter();
    },
    trial() {
      this.updateFilter();
    },
    test() {
      this.updateFilter();
    },
    kunde() {
      this.updateFilter();
    },
    newsletter() {
      this.updateFilter();
    },
  }
}
</script>
<style scoped>
.chartreuse {
background-color: #80FF00;
}
</style>